import React, { useState } from 'react';

export default function TitleVariations({ data }) {
  const [copied, setCopied] = useState(null);

  if (!data) {
    return <div className="title-variations"><p>No data available</p></div>;
  }

  const variations = Array.isArray(data?.titleVariations) ? data.titleVariations : [];

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="title-variations">
      <h3>📝 Recommended Video Titles</h3>
      {variations.length > 0 ? (
        <div className="variations-list">
          {variations.map((title, idx) => (
            <div key={idx} className="variation-item">
              <div className="variation-content">
                <span className="variation-number">{idx + 1}</span>
                <span className="variation-text">{title}</span>
              </div>
              <button 
                className="copy-btn"
                onClick={() => copyToClipboard(title)}
              >
                {copied === title ? '✅' : '📋'}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p>No title variations available</p>
      )}
    </div>
  );
}
